import { listRally, resultByRally,specialByRally,resultBySpecial,listClasse,specialByRallyrecap } from "./RallyData";
import { combineReducers } from "redux";

export default combineReducers({listRally,resultByRally,specialByRally,resultBySpecial,listClasse,specialByRallyrecap });